import { render } from "./dpw-table.vue?vue&type=template&id=508816f5&scoped=true"
import script from "./dpw-table.vue?vue&type=script&lang=js"
export * from "./dpw-table.vue?vue&type=script&lang=js"

import "./dpw-table.vue?vue&type=style&index=0&id=508816f5&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508816f5"]])

export default __exports__